import { GET } from '@/api';

const URL = 'review/reviewImages';

export default async ({ productCode, config, successCB, failCB }) => {
  try {
    const { data } = await GET(`${URL}/${productCode}`, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
